var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.125 10.75a.75.75 0 0 0 0 1.5zm.875.75h.75a.75.75 0 0 0-.75-.75zm-.75 6a.75.75 0 0 0 1.5 0zm10-5.5A9.25 9.25 0 0 1 12 21.25v1.5c5.937 0 10.75-4.813 10.75-10.75zM12 21.25A9.25 9.25 0 0 1 2.75 12h-1.5c0 5.937 4.813 10.75 10.75 10.75zM2.75 12A9.25 9.25 0 0 1 12 2.75v-1.5C6.063 1.25 1.25 6.063 1.25 12zM12 2.75A9.25 9.25 0 0 1 21.25 12h1.5c0-5.937-4.813-10.75-10.75-10.75zm-.875 9.5H12v-1.5h-.875zm.125-.75v6h1.5v-6zm.625-4.375v1.5a1.5 1.5 0 0 0 1.5-1.5zm0 0h-1.5a1.5 1.5 0 0 0 1.5 1.5zm0 0v-1.5a1.5 1.5 0 0 0-1.5 1.5zm0 0h1.5a1.5 1.5 0 0 0-1.5-1.5z"
  })));
};
export default SvgInfo;